import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * One SVG sprite instead of the Material Icons webfont.
 *
 * `assets/icons/sprite.svg` carries every symbol as `#<name>`; the set is the
 * approved mockups' operator sprite merged with the Design A web sprite.
 * Rendering through `<use>` means no font request, no ligature flash, and
 * `currentColor` for free.
 *
 * `[flip]` mirrors DIRECTIONAL glyphs (chevrons, back arrows, logout, send)
 * under RTL via the global `[dir='rtl'] .ui-icon--flip` rule in base.css.
 * Directional symbols are listed in the sprite's header comment; nothing else
 * may be flipped — a mirrored calendar or trash can is a bug, not a nicety.
 */
@Component({
  selector: 'ui-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-icon.component.html',
  styleUrls: ['./ui-icon.component.scss'],
})
export class UiIconComponent {
  /** Sprite symbol id, with or without the `i-` prefix: `i-car` or `car`. */
  @Input({ required: true }) name!: string;
  @Input() size: number | string = 18;
  /** Mirror under RTL. Only for glyphs that point somewhere. */
  @Input() flip = false;

  get href(): string {
    const id = this.name?.startsWith('i-') || this.name?.startsWith('logo-') ? this.name : `i-${this.name}`;
    return `assets/icons/sprite.svg#${id}`;
  }
}
